<template>
  <v-card elevation="0" color="grey lighten-4" class="mb-8">
    <v-card-text class="pb-0">
      <v-row>
        <v-col>
          <v-menu
            ref="datepicker"
            :close-on-content-click="false"
            v-model="datepicker"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :rules="[validDate]"
                v-model="departureDate"
                label="Datum"
                readonly
                outlined
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              locale="sv"
              first-day-of-week="1"
              v-model="departureDate"
              no-title
              @input="datepicker = false"
            />
          </v-menu>
        </v-col>
        <v-col>
          <v-text-field
            label="Tågnummer"
            outlined
            type="number"
            @keydown.enter.stop.prevent="onSearchTrain"
            v-model.number="searchValue"
            :rules="[required]"
          />
        </v-col>
        <v-col cols="auto">
          <v-btn
            x-large
            :loading="pending"
            color="grey lighten-2"
            @click="onSearchTrain"
          >
            <v-icon>mdi-magnify</v-icon> Sök
          </v-btn>
        </v-col>
      </v-row>
      <v-expand-transition>
        <v-row v-if="showResearch">
          <v-col>
            <v-alert dense outlined type="info">
              <span class="text-body-2">
                Tågnummret ändrat, gör en ny sökning
              </span>
            </v-alert>
          </v-col>
        </v-row>

        <v-row v-else-if="showNoResult">
          <v-col>
            <v-alert dense outlined type="warning">
              <span class="text-body-2">
                Inget tåg hittades, platslistan filtreras ej.
              </span>
            </v-alert>
          </v-col>
        </v-row>
      </v-expand-transition>
    </v-card-text>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import { validDate } from '@/common/validationRules'
import { format, startOfDay } from 'date-fns'
import { sync, get } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import gql from 'graphql-tag'

export default {
  name: 'RejectedStopActivitySearch',

  data: () => ({
    validDate,
    required,
    datepicker: false,
    departureDate: format(new Date(), 'yyyy-MM-dd'),
    showResearch: false,
    showNoResult: false,
    searchValue: null
  }),

  computed: {
    pending: sync('rejectedStop/pending@searchTrain'),
    model: sync('rejectedStop/model'),
    arrivalPlaces: get('trainDeviation/arrivalPlaces'),
    departurePlaces: get('trainDeviation/departurePlaces')
  },

  apollo: {
    searchTrain: {
      query: gql`
        query searchTrain($filter: SearchTrainInput!) {
          searchTrain(filter: $filter) {
            public_number
            places {
              type
              location
              location_long_name
              advertised
              delay_minutes
            }
          }
        }
      `,
      skip: true,
      variables() {
        return {
          filter: {
            train_number: this.model.train_number || null,
            date: this.departureDate
          }
        }
      },
      result({ data }) {
        this.$store.set('rejectedStop/model@places', null)
        this.pending = false
        if (!data.searchTrain) {
          this.showNoResult = true
        }
        this.pending = false
      }
    }
  },

  methods: {
    onSearchTrain() {
      this.showResearch = false
      this.showNoResult = false
      this.model.train_number = this.searchValue
      this.pending = true
      this.$apollo.queries.searchTrain.skip = false
    }
  },

  watch: {
    searchValue(v) {
      this.$store.set('rejectedStop/model@places', null)
      if (this.model.train_number !== null) {
        this.showResearch = true
      }

      if (this.model.train_number === v) {
        this.showResearch = false
      }
    },

    departureDate() {
      this.$store.set(
        'rejectedStop/model@departure_date',
        format(new Date(this.departureDate), 'yyyy-MM-dd')
      )
    },

    searchTrain: {
      handler(value) {
        if (this.$apollo.queries.searchTrain) {
          this.$apollo.queries.searchTrain.skip = true
        }

        if (!value) {
          this.$store.set('trainDeviation/places', [])
          this.$store.set('rejectedStop/model@type', 'TJT')

          this.$store.set(
            'rejectedStop/model@departure',
            startOfDay(new Date(this.departureDate))
          )
          this.$store.set(
            'rejectedStop/model@arrival',
            startOfDay(new Date(this.departureDate))
          )
          this.$store.set(
            'rejectedStop/model@departure_date',
            format(new Date(this.departureDate), 'yyyy-MM-dd')
          )

          return
        }

        this.$store.set('trainDeviation/places', value.places)
        this.$store.set('rejectedStop/model@type', 'RST')

        const arrivalPlace = this.arrivalPlaces[this.arrivalPlaces.length - 1]
        this.$store.set(
          'rejectedStop/model@arrival',
          new Date(arrivalPlace.advertised)
        )

        const departurePlace = this.departurePlaces[0]
        this.$store.set(
          'rejectedStop/model@departure',
          new Date(departurePlace.advertised)
        )
        this.$store.set(
          'rejectedStop/model@departure_date',
          format(new Date(this.departureDate), 'yyyy-MM-dd')
        )
      }
    }
  }
}
</script>
